import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import useInterviews from '../useInterviews';
import FormHelper from 'helpers/FormHelper';

const AnswersEdit = () => {
  const { t } = useTranslation();
  const { form, handleAnswerQuestions, updateInProcess, singleItem } =
    useInterviews(false, false, false, false, true);
  const onFinish = async (values) => {
    await handleAnswerQuestions(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const interview_questions = singleItem?.interview_questions || [];

  return (
    <div>
      <PageHeader title={singleItem?.title}>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
        >
          {interview_questions.map((question, index) => (
            <InfoSection key={index} question={question} index={index} />
          ))}
        </Form>
      </div>
    </div>
  );
};

export default AnswersEdit;
